import { Expression, NamedColumn } from '../../../types';

export default function linkedTasksHandler(
  column: NamedColumn, expression: Expression,
): Expression {
  return {
    ...expression,
    field: column.identifier(),
    operator: 'is_not_empty',
  };
}
